module.exports = __webpack_public_path__ + "img/arrow_down_g.fd91f30f.svg";